// extracted by mini-css-extract-plugin
export var breadcrumbs = "breadcrumbs__Mel0";
export var faqContainer = "faqContainer__GM4K";
export var linksContainer = "linksContainer__blQF";